<template>
  <div class="mp-skeleton">
    <div class="skeleton_top"></div>
    <div v-for="(data, index) in dataList1" :key="index">
      <div class="skeleton">
        <div class="skeleton_img"></div>
        <div class="skeleton_conetxt">
          <div class="skeleton_title_0"></div>
          <div class="skeleton_subtitle"></div>
        </div>
      </div>
      <div class="dataItem"></div>
      <div class="dataItem"></div>
      <div class="dataItem"></div>
    </div>
    <div class="skeleton">
      <div class="skeleton_img"></div>
      <div class="skeleton_conetxt">
        <div class="skeleton_title_0"></div>
        <div class="skeleton_subtitle"></div>
      </div>
    </div>
    <div class="dataItem"></div>
    <div class="dataItem"></div>
    <div class="dataItem"></div>
    <div class="dataItem"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dataList1: [1, 2],
      dataList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    };
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.mp-skeleton {
  animation-duration: 1.5s;
  animation-name: blink;
  animation-iteration-count: infinite;
  background: #e8eaec;
  opacity: 0.5;
  padding: 5px 10px;
  .skeleton_top {
    height: 180px;
    width: 100%;
    background: #c5c8ce;
  }
  .skeleton {
    margin: 15px 0;
    display: flex;
    justify-content: flex-start;
    .dataItem {
      margin: 10px 0;
      height: 30px;
      background: #c5c8ce;
      border-radius: 5px;
    }
    .skeleton_img {
      width: 100px;
      height: 100px;
      background: #c5c8ce;
      border-radius: 5px;
    }
    .skeleton_title {
      width: 80%;
      height: 40px;
      background: #c5c8ce;
      margin: 0 10px;
      border-radius: 5px;
    }
    .skeleton_conetxt {
      width: 100%;
      height: 100px;
      text-align: center;
      padding-left: 10px;
      border-radius: 5px;
      .skeleton_title_0 {
        width: 100%;
        height: 55px;
        background: #c5c8ce;
        margin-bottom: 10px;
        border-radius: 5px;
      }
      .skeleton_subtitle {
        width: 100%;
        height: 35px;
        background: #c5c8ce;
        border-radius: 5px;
      }
    }
  }

  .dataItem {
    margin: 10px 0;
    height: 30px;
    background: #c5c8ce;
    border-radius: 5px;
  }
}

@keyframes blink {
  0% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.4;
  }
}

@keyframes flush {
  0% {
    left: -100%;
  }

  50% {
    left: 0;
  }

  100% {
    left: 100%;
  }
}
</style>
